(function () {
  const money = (cents) => {
    const fmt = (window.ufcMoneyFormat || 'Rs. {{amount}}');
    const amount = (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const noDec = Math.round(cents / 100).toLocaleString('en-IN');
    return fmt.replace(/\{\{\s*amount_no_decimals[^}]*\}\}/, noDec).replace(/\{\{\s*amount[^}]*\}\}/, amount);
  };

  const mainSection = () => document.querySelector('product-info[id^="MainProduct-"]');
  const mainForm = () => {
    const s = mainSection();
    return s ? s.querySelector('form[action*="/cart/add"].form, product-form form[action*="/cart/add"]') : null;
  };
  const mainVariantId = () => {
    const f = mainForm();
    const input = f && f.querySelector('input[name="id"]');
    return input ? Number(input.value) : null;
  };

  const renderCart = async (items) => {
    const drawer = document.querySelector('cart-drawer');
    const notification = document.querySelector('cart-notification');
    const cart = drawer || notification;
    const body = { items };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
    }
    const res = await fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to bag');
    return { data, cart };
  };

  const openCart = (data, cart) => {
    const first = (data.items && data.items[0]) || data;
    if (cart && typeof cart.renderContents === 'function' && data.sections) {
      if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      cart.renderContents(Object.assign({}, first, { sections: data.sections }));
    } else {
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    }
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ufc-pdp', cartData: data });
    }
  };

  class UfcOffers extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-copy]');
        if (!btn) return;
        const code = btn.dataset.copy;
        const done = () => {
          btn.classList.add('is-copied');
          btn.textContent = btn.dataset.copied || 'Copied';
          setTimeout(() => {
            btn.classList.remove('is-copied');
            btn.textContent = btn.dataset.label || 'Copy';
          }, 2000);
        };
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(code).then(done, () => this.fallbackCopy(code, done));
        } else {
          this.fallbackCopy(code, done);
        }
      });
    }
    fallbackCopy(code, done) {
      const t = document.createElement('textarea');
      t.value = code;
      t.setAttribute('readonly', '');
      t.style.position = 'fixed';
      t.style.opacity = '0';
      document.body.appendChild(t);
      t.select();
      try { document.execCommand('copy'); } catch (err) {}
      t.remove();
      done();
    }
  }
  if (!customElements.get('ufc-offers')) customElements.define('ufc-offers', UfcOffers);

  class UfcPincode extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      this.result = this.querySelector('[data-result]');
      this.error = this.querySelector('[data-error]');
      this.querySelector('form').addEventListener('submit', (e) => {
        e.preventDefault();
        this.check(true);
      });
      this.input.addEventListener('input', () => {
        this.input.value = this.input.value.replace(/\D/g, '').slice(0, 6);
        this.error.hidden = true;
      });
      let saved = null;
      try { saved = localStorage.getItem('ufc_pincode'); } catch (err) {}
      if (saved && /^[1-9]\d{5}$/.test(saved)) {
        this.input.value = saved;
        this.check(false);
      }
    }
    check(store) {
      const pin = this.input.value.trim();
      if (!/^[1-9]\d{5}$/.test(pin)) {
        this.result.hidden = true;
        this.error.hidden = false;
        return;
      }
      this.error.hidden = true;
      const days = Number(this.dataset.days || 7);
      const date = new Date();
      date.setDate(date.getDate() + days);
      const label = date.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
      const by = this.result.querySelector('[data-date]');
      if (by) by.textContent = label;
      const pinEl = this.result.querySelector('[data-pin]');
      if (pinEl) pinEl.textContent = pin;
      this.result.hidden = false;
      if (store) {
        try { localStorage.setItem('ufc_pincode', pin); } catch (err) {}
      }
    }
  }
  if (!customElements.get('ufc-pincode')) customElements.define('ufc-pincode', UfcPincode);

  class UfcLook extends HTMLElement {
    connectedCallback() {
      try { this.data = JSON.parse(this.querySelector('script[type="application/json"]').textContent); } catch (err) { return; }
      this.saving = Number(this.dataset.saving || 0);
      this.code = this.dataset.code || '';
      this.msg = this.querySelector('[data-msg]');
      this.querySelectorAll('select[data-product]').forEach((sel) => sel.addEventListener('change', () => this.update()));
      this.querySelectorAll('[data-add]').forEach((btn) => btn.addEventListener('click', () => this.addOne(btn)));
      const all = this.querySelector('[data-add-all]');
      if (all) all.addEventListener('click', () => this.addAll(all));
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsub = subscribe(PUB_SUB_EVENTS.variantChange, () => this.update());
      }
      this.update();
    }
    disconnectedCallback() {
      if (this.unsub) this.unsub();
    }
    variantFor(index) {
      const product = this.data[index];
      if (!product) return null;
      if (product.current) {
        const id = mainVariantId();
        return product.variants.find((v) => v.id === id) || product.variants.find((v) => v.available) || product.variants[0];
      }
      const sel = this.querySelector(`[data-product="${index}"]`);
      const id = sel ? Number(sel.value) : product.variants[0].id;
      return product.variants.find((v) => v.id === id);
    }
    update() {
      let total = 0;
      let ready = true;
      this.data.forEach((p, i) => {
        const v = this.variantFor(i);
        if (!v || !v.available) { ready = false; return; }
        total += v.price;
        const row = this.querySelector(`[data-row="${i}"]`);
        if (row) {
          row.querySelector('[data-price]').textContent = money(v.price);
          const c = row.querySelector('[data-compare]');
          if (c) {
            c.textContent = v.compare > v.price ? money(v.compare) : '';
          }
          const btn = row.querySelector('[data-add]');
          if (btn) btn.disabled = !v.available;
        }
      });
      const final = Math.max(total - this.saving, 0);
      const t = this.querySelector('[data-total]');
      const tc = this.querySelector('[data-total-compare]');
      if (t) t.textContent = money(final);
      if (tc) tc.textContent = total > final ? money(total) : '';
      const all = this.querySelector('[data-add-all]');
      if (all) all.disabled = !ready;
    }
    say(text) {
      if (this.msg) {
        this.msg.textContent = text;
        this.msg.hidden = !text;
      }
    }
    async addOne(btn) {
      const v = this.variantFor(Number(btn.dataset.add));
      if (!v || !v.available) return;
      const label = btn.textContent;
      btn.disabled = true;
      this.say('');
      try {
        const { data, cart } = await renderCart([{ id: v.id, quantity: 1 }]);
        btn.classList.add('is-done');
        btn.textContent = btn.dataset.done || 'Added';
        openCart(data, cart);
        setTimeout(() => { btn.classList.remove('is-done'); btn.textContent = label; btn.disabled = false; }, 2200);
      } catch (err) {
        this.say(err.message);
        btn.textContent = label;
        btn.disabled = false;
      }
    }
    async addAll(btn) {
      const items = this.data.map((p, i) => this.variantFor(i)).filter((v) => v && v.available).map((v) => ({ id: v.id, quantity: 1 }));
      if (items.length !== this.data.length) return;
      const label = btn.textContent;
      btn.disabled = true;
      btn.textContent = btn.dataset.loading || 'Adding...';
      this.say('');
      try {
        if (this.code) {
          await fetch('/discount/' + encodeURIComponent(this.code) + '?redirect=/cart.js').catch(() => {});
        }
        const { data, cart } = await renderCart(items);
        openCart(data, cart);
      } catch (err) {
        this.say(err.message);
      }
      btn.textContent = label;
      btn.disabled = false;
      this.update();
    }
  }
  if (!customElements.get('ufc-look')) customElements.define('ufc-look', UfcLook);

  class UfcSticky extends HTMLElement {
    connectedCallback() {
      try { this.variants = JSON.parse(this.querySelector('script[type="application/json"]').textContent); } catch (err) { this.variants = []; }
      this.btn = this.querySelector('[data-sticky-add]');
      this.btnText = this.btn.dataset.add;
      this.btnSold = this.btn.dataset.sold;
      this.sizes = this.querySelector('[data-sizes]');
      this.optionIndex = Number(this.dataset.optionIndex || 0);
      if (this.sizes) {
        this.sizes.addEventListener('click', (e) => {
          const b = e.target.closest('[data-value]');
          if (b) this.pick(b.dataset.value);
        });
      }
      this.btn.addEventListener('click', () => this.add());
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsub = subscribe(PUB_SUB_EVENTS.variantChange, (e) => this.sync(e && e.data && e.data.variant));
      }
      this.observe();
      this.sync();
      document.body.classList.add('ufc-has-sticky');
    }
    disconnectedCallback() {
      if (this.unsub) this.unsub();
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }
    observe() {
      const footer = document.querySelector('.main-footer, footer');
      let ticking = false;
      const apply = () => {
        ticking = false;
        const target = document.querySelector(this.dataset.watch);
        if (!target) return;
        const r = target.getBoundingClientRect();
        const past = r.bottom < 0;
        const footerIn = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
        this.classList.toggle('is-visible', past && !footerIn);
      };
      this.onScroll = () => {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(apply);
        }
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      apply();
    }
    current() {
      const id = mainVariantId();
      return this.variants.find((v) => v.id === id) || null;
    }
    sync(variant) {
      const v = variant ? this.variants.find((x) => x.id === variant.id) || variant : this.current();
      if (this.sizes) {
        this.sizes.querySelectorAll('[data-value]').forEach((b) => {
          const value = b.dataset.value;
          const match = this.matchFor(value, v);
          b.classList.toggle('is-active', !!v && this.valueOf(v) === value);
          b.classList.toggle('is-unavailable', !match || !match.available);
        });
      }
      if (!v) return;
      const price = this.querySelector('[data-price]');
      const compare = this.querySelector('[data-compare]');
      const off = this.querySelector('[data-off]');
      if (price) price.textContent = money(v.price);
      if (compare) compare.textContent = v.compare > v.price ? money(v.compare) : '';
      if (off) {
        const pct = v.compare > v.price ? Math.round(((v.compare - v.price) * 100) / v.compare) : 0;
        off.textContent = pct ? pct + '% OFF' : '';
        off.hidden = !pct;
      }
      this.btn.disabled = !v.available;
      this.btn.textContent = v.available ? this.btnText : this.btnSold;
    }
    valueOf(v) {
      return v && v.options ? v.options[this.optionIndex] : null;
    }
    matchFor(value, base) {
      const others = base && base.options ? base.options : null;
      return this.variants.find((v) => v.options[this.optionIndex] === value && (!others || v.options.every((o, i) => i === this.optionIndex || o === others[i])))
        || this.variants.find((v) => v.options[this.optionIndex] === value);
    }
    holdScroll() {
      if (!window.__ufcScrollTo) {
        window.__ufcScrollTo = window.scrollTo.bind(window);
        window.scrollTo = function (a, b) {
          if (window.__ufcHoldUntil > Date.now() && a && typeof a === 'object' && a.behavior === 'smooth') return;
          return window.__ufcScrollTo(a, b);
        };
        const focus = HTMLElement.prototype.focus;
        HTMLElement.prototype.focus = function (opts) {
          if (window.__ufcHoldUntil > Date.now() && this.closest && this.closest('variant-selects')) {
            return focus.call(this, Object.assign({}, opts, { preventScroll: true }));
          }
          return focus.call(this, opts);
        };
      }
      window.__ufcHoldUntil = Date.now() + 2500;
    }
    pick(value) {
      const section = mainSection();
      if (!section) return;
      this.holdScroll();
      const inputs = section.querySelectorAll('variant-selects input[type="radio"]');
      const input = Array.from(inputs).find((i) => i.value === value && i.closest('fieldset') === i.closest('variant-selects').querySelectorAll('fieldset')[this.optionIndex]);
      if (input) {
        input.click();
      } else {
        const select = section.querySelectorAll('variant-selects select')[this.optionIndex];
        if (select) {
          const opt = Array.from(select.options).find((o) => o.value === value || o.textContent.trim() === value);
          if (opt) {
            select.value = opt.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
      const optimistic = this.matchFor(value, this.current());
      if (optimistic) this.sync(optimistic);
    }
    add() {
      const f = mainForm();
      const submit = f && f.querySelector('[type="submit"]');
      if (submit && !submit.disabled) {
        submit.click();
      } else if (submit) {
        submit.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }
  if (!customElements.get('ufc-sticky-atc')) customElements.define('ufc-sticky-atc', UfcSticky);

  const sizeIcon = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.3"><circle cx="8" cy="8" r="6.5"/><path d="M8 7.2v4M8 4.8v.4"/></svg>';
  const closeIcon = '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M1 1l10 10M11 1L1 11"/></svg>';

  const initSizeBox = () => {
    const box = document.querySelector('.size-box');
    const cfg = document.getElementById('ufc-sizebox-config');
    if (!box || !cfg || box.classList.contains('ufc-sizebox')) return;
    let conf = {};
    try { conf = JSON.parse(cfg.textContent); } catch (err) {}
    const chart = box.querySelector('.size-chart');
    if (!chart) return;
    const titleP = chart.querySelector(':scope > p');
    const unitMatch = titleP ? /\((inch|inches|cm)\)/i.exec(titleP.textContent) : null;
    const baseUnit = unitMatch && /cm/i.test(unitMatch[1]) ? 'cm' : 'in';

    box.classList.add('ufc-sizebox');
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('data-lenis-prevent', '');
    const sheet = document.createElement('div');
    sheet.className = 'ufc-sizebox__sheet';
    sheet.innerHTML =
      '<div class="ufc-sizebox__top"><p class="ufc-sizebox__heading"></p><button type="button" class="ufc-sizebox__close" aria-label="Close">' + closeIcon + '</button></div>' +
      '<p class="ufc-sizebox__sub"></p>' +
      '<div class="ufc-sizebox__units" role="group"><button type="button" data-unit="in">Inches</button><button type="button" data-unit="cm">CM</button></div>';
    sheet.querySelector('.ufc-sizebox__heading').textContent = conf.heading || 'Size guide';
    sheet.querySelector('.ufc-sizebox__sub').textContent = conf.sub || '';
    box.insertBefore(sheet, chart);
    sheet.appendChild(chart);
    const tips = document.createElement('div');
    tips.className = 'ufc-sizebox__tips';
    (conf.tips || []).filter(Boolean).forEach((text) => {
      const p = document.createElement('p');
      p.className = 'ufc-sizebox__tip';
      p.innerHTML = sizeIcon + '<span></span>';
      p.querySelector('span').textContent = text;
      tips.appendChild(p);
    });
    sheet.appendChild(tips);
    document.body.appendChild(box);

    const cells = Array.from(chart.querySelectorAll('tr:not(.c-th) td:not(:first-child)'));
    cells.forEach((td) => { td.dataset.base = td.textContent.trim(); });
    const setUnit = (unit) => {
      cells.forEach((td) => {
        const n = parseFloat(td.dataset.base);
        if (isNaN(n) || unit === baseUnit) { td.textContent = td.dataset.base; return; }
        const v = unit === 'cm' ? n * 2.54 : n / 2.54;
        td.textContent = (Math.round(v * 2) / 2).toString();
      });
      sheet.querySelectorAll('[data-unit]').forEach((b) => b.classList.toggle('is-active', b.dataset.unit === unit));
    };
    sheet.querySelectorAll('[data-unit]').forEach((b) => b.addEventListener('click', () => setUnit(b.dataset.unit)));
    setUnit(baseUnit);

    const highlight = () => {
      const section = mainSection();
      const checked = section && section.querySelector('variant-selects input[type="radio"]:checked');
      const val = checked ? checked.value.trim().toLowerCase() : '';
      chart.querySelectorAll('tr:not(.c-th)').forEach((tr) => {
        const first = tr.querySelector('td');
        tr.classList.toggle('is-selected', !!first && first.textContent.trim().toLowerCase() === val);
      });
    };
    const close = () => box.classList.remove('size-box-active');
    sheet.querySelector('.ufc-sizebox__close').addEventListener('click', close);
    box.addEventListener('click', (e) => { if (e.target === box) close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
    new MutationObserver(() => {
      if (box.classList.contains('size-box-active')) highlight();
    }).observe(box, { attributes: true, attributeFilter: ['class'] });
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-ufc-fit]')) {
        e.preventDefault();
        box.classList.add('size-box-active');
      }
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSizeBox);
  else initSizeBox();

  const initRelated = () => {
    const rec = document.querySelector('product-recommendations.related-products');
    if (!rec) return;
    const setup = () => {
      const list = rec.querySelector('.product-grid');
      if (!list || list.dataset.ufcSlider) return;
      list.dataset.ufcSlider = '1';
      const bar = document.createElement('div');
      bar.className = 'ufc-related-progress';
      bar.innerHTML = '<span></span>';
      list.after(bar);
      const thumb = bar.firstElementChild;
      const update = () => {
        const max = list.scrollWidth - list.clientWidth;
        const ratio = list.scrollWidth ? list.clientWidth / list.scrollWidth : 1;
        thumb.style.width = Math.min(100, ratio * 100) + '%';
        const pos = max > 0 ? list.scrollLeft / max : 0;
        thumb.style.transform = 'translateX(' + pos * (1 / ratio - 1) * 100 + '%)';
        bar.style.visibility = max > 2 ? 'visible' : 'hidden';
      };
      list.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    };
    setup();
    new MutationObserver(setup).observe(rec, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initRelated);
  else initRelated();
})();
